export const OVERVIEW_TABS = [{ label: 'Play by Play', value: 'play-by-play' }];
